import Vue from "vue";
import Vuex from "vuex";
import * as getters from "./getters";
import * as actions from "./actions";
import mutations from "./mutations";

Vue.use(Vuex);

const state = {
  // 用户是否通过OSS登录
  oss: Boolean(sessionStorage.getItem("oss")),
  user: {
    username: "",
    id: "",
  },
  isLogin: false,
  regionWidthChangedNum: 1,
  isMigratory: false,
};

export default new Vuex.Store({
  state,
  getters,
  actions,
  mutations,
});



// WEBPACK FOOTER //
// ./src/store/index.js